import { render, staticRenderFns } from "./RdvItem.vue?vue&type=template&id=38a4ccf9&"
import script from "./RdvItem.vue?vue&type=script&lang=js&"
export * from "./RdvItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports